// // src/providers/GoogleAuthProvider.js
// import React from "react";
// import { GoogleOAuthProvider } from "@react-oauth/google";

// const clientId = "844013135626-o9l89dbc9qarjvm01oo98t66v96j3ubm.apps.googleusercontent.com"; 
// // 👆 replace with your real Client ID (not API key)

// export default function GoogleAuthProvider({ children }) {
//   return <GoogleOAuthProvider clientId={clientId}>{children}</GoogleOAuthProvider>;
// }


// src/providers/GoogleAuthProvider.js
import React, { createContext, useState, useContext } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

// Create context
const GoogleAuthContext = createContext();


export const useGoogleAuth = () => useContext(GoogleAuthContext);

const clientId =
  "844013135626-o9l89dbc9qarjvm01oo98t66v96j3ubm.apps.googleusercontent.com";

export default function GoogleAuthProvider({ children }) {
  const [googleToken, setGoogleToken] = useState(null);

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleAuthContext.Provider value={{ googleToken, setGoogleToken }}>
        {children}
      </GoogleAuthContext.Provider>
    </GoogleOAuthProvider>
  );
}
